import React from 'react';
import { referencesData } from '../constant/Data';



const ScientificReferences = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold text-center mb-8">Scientific References</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {referencesData.map((ref, index) => (
                    <a
                        key={index}
                        href={ref}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-gray-700 hover:text-black hover:underline break-words"
                    >
                        {ref}
                    </a>
                ))}
            </div>
        </div>
    );
};

export default ScientificReferences;

